<template>
  <Form
    ref="formRef"
    :rules="ruleValidate"
    :model="formData"
    label-position="top"
  >
    <FormItem label="IP地址" prop="portName" key="portName">
      <Input v-model="formData.portName" placeholder="请输入" />
    </FormItem>
    <FormItem label="端口号" key="parameter1" prop="parameter1">
      <Input v-model="formData.parameter1" type="number" placeholder="请输入" />
    </FormItem>
    <FormItem label="设备号" key="parameter2" prop="parameter2">
      <Input v-model="formData.parameter2" type="number" placeholder="请输入" />
    </FormItem>
    <FormItem
      label="采集周期（毫秒）"
      key="interval"
      prop="interval"
    >
      <Input v-model="formData.interval" type="number" placeholder="请输入" />
    </FormItem>
    <FormItem
      label="轮询延时（毫秒)"
      key="pollsDelay"
      prop="pollsDelay"
    >
      <Input v-model="formData.pollsDelay" type="number" placeholder="请输入" />
    </FormItem>
    <FormItem
      label="响应超时（毫秒)"
      key="responseTimeout"
      prop="responseTimeout"
    >
      <Input v-model="formData.responseTimeout" type="number" placeholder="请输入" />
    </FormItem>
    <FormItem
      label="最大读写寄存器数"
      key="parameter3"
      prop="parameter3"
    >
      <Input v-model="formData.parameter3" type="number" placeholder="请输入" />
    </FormItem>
  </Form>
</template>

<script>
const staticparameterList = [
  'portName',
  'parameter1',
  'parameter2',
  'parameter3',
  'interval',
  'pollsDelay',
  'responseTimeout',
];
export default {
  name: 'FormETHERNET',
  props: {
    defaultFormData: {
      type: Object,
      default: () => null,
    },
  },
  watch: {
    defaultFormData: function (newValue) {
      if (newValue) {
        staticparameterList.forEach((option) => {
          if (option === 'interval') {
            this.formData[option] = newValue[option] || '1000';
          } else if (option === 'pollsDelay') {
            this.formData[option] = newValue[option] || '100';
          } else if (option === 'responseTimeout') {
            this.formData[option] = newValue[option] || '500';
          } else if (option === 'parameter3') {
            this.formData[option] = newValue[option] || '125';
          } else {
            this.formData[option] = newValue[option];
          }
        });
      }
    },
  },
  data: function () {
    return {
      formData: {
        portName: '',
        parameter1: '',
        parameter2: '',
        parameter3: '',
        interval: '',
        pollsDelay: '',
        responseTimeout: '',
      },
      ruleValidate: {
        portName: [
          {
            required: true,
            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let value1 = this.formData.portName;
              if (!value1) {
                callback(new Error("请输入IP地址"));
              } else {
                const splitPort = value1.split('.');

                if (splitPort.length === 4 && splitPort.every((item) => {
                  let itemPort = -1;

                  if (/^[0-9]*$/.test(item)) {
                    itemPort = parseInt(item);
                  }

                  return itemPort >= 0 && itemPort < 256;
                })) {
                  callback();
                } else {
                  callback(new Error('请正确输入ip地址'));
                }
              }
            },
          },
        ],
        parameter1: [
          {
            required: true,
            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let value1 = this.formData.parameter1;
              console.log('parameter1', parseInt(value1));
              if (!value1) {
                callback(new Error("请输入端口号"));
              } else if (parseInt(value1) < 0 || parseInt(value1) > 65535) {
                console.log('请正确填写端口号');
                callback(new Error('请正确填写端口号'));
              }
              callback();
            },
          },
        ],
        parameter2: [
          {
            required: true,
            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let value1 = this.formData.parameter2;
              if (!value1) {
                callback(new Error("请填写设备号"));
              } else if (parseInt(value1) <= 0) {
                callback(new Error('请正确填写设备号'));
              }
              callback();
            },
          },
        ],
        parameter3: [
          {
            required: true,
            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let value1 = this.formData.parameter3;
              if (!value1) {
                callback(new Error("请填写最大读写寄存器数"));
              } else if (parseInt(value1) <= 0) {
                callback(new Error('请正确填写最大读写寄存器数'));
              }
              callback();
            },
          },
        ],
        interval: [
          {
            required: true,
            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let value1 = this.formData.interval;
              if (!value1) {
                callback(new Error("请填写采集周期"));
              } else if (parseInt(value1) <= 0) {
                callback(new Error('请正确填写采集周期'));
              }
              callback();
            },
          },
        ],
        pollsDelay: [
          {
            required: true,
            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let value1 = this.formData.pollsDelay;

              if (!value1) {
                callback(new Error("请填写轮询延时"));
              } else if (parseInt(value1) <= 0) {
                callback(new Error('请正确填写轮询延时'));
              }
              callback();
            },
          },
        ],
        responseTimeout: {
          required: true,
          trigger: "blur,change",
          validator: (rule, value, callback) => {
            let value1 = this.formData.responseTimeout;

            if (!value1) {
              callback(new Error("请填写响应超时时间"));
            } else if (parseInt(value1) <= 0) {
              callback(new Error('请正确填写响应超时时间'));
            }
            callback();
          },
        },
      },
    };
  },
  methods: {
    resetFields: function () {
      this.$refs.formRef.resetFields();
    },
    validate: function (callback) {
      this.$refs.formRef.validate((valid) => {
        callback(valid, this.formData);
      });
    },
  },
};
</script>

<style></style>
